import React, {useState, useEffect, useRef} from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import {gsap, Power3} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import src from "gsap/src";

const Container = styled.div`
    :not(:last-child){
        margin-bottom: 50px;
    }
`;

const Title = styled.span`
    font-size: 17px;
    font-weight: 600;
    
`;

const Grid = styled.div`
    margin-top: 25px;
    display: grid;
    grid-template-columns: repeat(auto-fill, 125px);
    grid-gap: 20px;
`;

const useScroll = () => {
    const scr = useRef();
    gsap.registerPlugin(ScrollTrigger);
    useEffect(() => {
        gsap.from(scr.current, {x: 1000, opacity: 0, duration: 1, ease: Power3.easeOut, scrollTrigger: {
            trigger: scr.current,
            markers: false,
            start: "top 75%",
            end: "bottom 25%",
            

        }});
    }, []);

    return {scr};
}




const Section = ({title, children}) => {

    
    const {scr} = useScroll();
    return(
        <Container>
            <Title>{title}</Title>
            <Grid ref={scr} >{children}</Grid>
        </Container>
    )};

Section.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node])
}
export default Section;